import { Box } from '@alf/uikit';
import Spinner from './img/spinner.svg';

import styles from './index.module.css';

export const Loader = ({ isLoading }) => {
  return isLoading ? (
    <Box className={styles.wrapper} justify="center">
      <Spinner className={styles.spinner} />
    </Box>
  ) : null;
};
